<template>
  <div class="admin-header">
    <h2>Most Popular Assignments</h2>
  </div>
  <TableData
    :headers="dynamicHeaders"
    :items="paginatedTrackItems"
    :total-pages="totalPages"
    :current-page="currentPage"
    @update:current-page="handlePageChange"
    @sort="handleSort"
    variant="rounded"
    :use-api-sort="true"
  />
</template>

<script setup>
import { computed, ref, watch } from "vue";
import TableData from "@/components/common/TableData.vue";
import { sfiStore } from "@/services/sfiService";

const currentPage = ref(1);
const sortBy = ref("");
const sortOrder = ref("asc");
const itemsPerPage = 4;

const dynamicHeaders = ref([
  {
    text: "Name",
    value: "name",
    sortable: true,
  },
  {
    text: "Number of Assignments",
    value: "number_of_times_assigned",
    sortable: true,
  },
]);

const trackItems = computed(() => {
  return (
    sfiStore.data?.top5StarterPack?.map((item) => ({
      // title and assigned_count
      name: item.title,
      number_of_times_assigned: item.count,
    })) || []
  );
});

const sortedTrackItems = computed(() => {
  if (!sortBy.value) return trackItems.value;

  return [...trackItems.value].sort((a, b) => {
    const valueA = a[sortBy.value];
    const valueB = b[sortBy.value];

    if (valueA === null || valueA === undefined) return 1;
    if (valueB === null || valueB === undefined) return -1;

    if (valueA < valueB) return sortOrder.value === "asc" ? -1 : 1;
    if (valueA > valueB) return sortOrder.value === "asc" ? 1 : -1;
    return 0;
  });
});

const totalPages = computed(() => {
  return Math.max(1, Math.ceil(trackItems.value.length / itemsPerPage));
});

const paginatedTrackItems = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  return sortedTrackItems.value.slice(start, start + itemsPerPage);
});

const handlePageChange = (page) => {
  currentPage.value = page;
};

const handleSort = ({ sort_by: field, sort_dir: direction }) => {
  sortBy.value = field;
  sortOrder.value = direction?.toLowerCase() === "desc" ? "desc" : "asc";
  currentPage.value = 1;
};

watch(totalPages, (pageCount) => {
  if (currentPage.value > pageCount) {
    currentPage.value = pageCount;
  }
});
</script>
